import { Wrap, Tag, TagCloseButton } from '@wegroup/design-system';
import { GbiCode } from '../../../../types/CompanyScanTypes';

interface Props {
  gbiCodes: GbiCode[];
  onRemove: (gbi: GbiCode) => void;
}

const GbiCodeTags = ({ gbiCodes, onRemove }: Props) => {
  return (
    <Wrap spacing="2" flexShrink={0}>
      {gbiCodes.map((gbiCode) => (
        <Tag key={gbiCode.code}>
          {gbiCode.code}: {gbiCode.label}
          <TagCloseButton onClick={() => onRemove(gbiCode)} />
        </Tag>
      ))}
    </Wrap>
  );
};

export default GbiCodeTags;
